import { stringToEnum } from '@snap-types/util/enum';

export enum ERPDB {
  VISUAL = 'VISUAL',
  VISUALSPR = 'VISUALSPR',
  VISUALFAS = 'VISUALFAS',
  EPICOR = 'EPICOR',
}

export const erpDBSchema = stringToEnum(ERPDB);
